import ContextMenuData from './ContextMenuData';
import createAddinContextMenuDataItem from './createAddinContextMenuDataItem';
import strings from 'owa-strings/owa-extensibility-strings';
import { Addin } from 'owa-addins-store';

export default function createOverflowContextMenuData(addins: Addin[]): ContextMenuData {
    const data = new ContextMenuData('AddinsHeader', strings.overflowMenuHeaderAddins);
    for (const addin of addins) {
        data.addItem(createAddinContextMenuDataItem(addin));
    }
    return data;
}
